import { red, yellow, green, blue, royalblue, orange, purple } from "@/theme";
import { find, get } from "lodash";

// Color configuration system - safe mapping without eval
export const COLOUR_PALETTES: any = {
  red: { text: red[900], background: red[25], backgroundBright: red[50], border: red[500] },
  yellow: { text: yellow[900], background: yellow[25], backgroundBright: yellow[50], border: yellow[500] },
  green: { text: green[900], background: green[25], backgroundBright: green[50], border: green[500] },
  blue: { text: blue[900], background: blue[25], backgroundBright: blue[50], border: blue[500] },
  royalblue: { text: royalblue[900], background: royalblue[25], backgroundBright: royalblue[50], border: royalblue[500] },
  orange: { text: orange[900], background: orange[25], backgroundBright: orange[50], border: orange[500] },
  purple: { text: purple[900], background: purple[25], backgroundBright: purple[50], border: purple[500] },
} as const;
export type ColourPaletteName = keyof typeof COLOUR_PALETTES;

// Helper function to get colours safely at runtime
export const getTriageLevelColours = (colorPalette: ColourPaletteName) => {
  return COLOUR_PALETTES[colorPalette];
};

// Helper function to get colours for a triage level from settings
export const getTriageLevelColoursFromSettings = (triageLevels: any[], value: number) => {
  const level = triageLevels.find(lvl => lvl.value === value);
  if (level && level.colourPalette) {
    return getTriageLevelColours(level.colourPalette);
  }
  // Fallback to default colours if not found
  return getTriageLevelColours("royalblue");
};


export const getTriageFromSettings = (score: any, settings: any) => {
  if (!settings || !score) return;
  const levels = get(settings, "encounter.triageLevels", []);
  const match = find(levels, { value: score });
  if (!match) return;
  return match;
};